const textProps = {
  copyright: {
    children: "Agentwire",
    href: "https://www.agentwire.ai",
    target: "_blank",
  },
  links: [
    {
      children: "Agentwire",
      href: "https://www.agentwire.ai",
      target: "_blank",
    },
    {
      children: "About us",
      href:  "https://www.agentwire.ai/about-us",
      target: "_blank",
    },
  ],
};
export default textProps;
